import { ArrowRightIcon, InfoIcon } from "lucide-react"

export function ShipmentRouteInfoBlock({
  title,
  origin,
  destination,
  km,
  code,
  showKm = true,
}: {
  title: string
  origin: string | null | undefined
  destination: string | null | undefined
  km: number | null | undefined
  code?: string | null | undefined
  showKm?: boolean
}) {
  return (
    <div className="grid gap-1.5 rounded-lg border border-blue-200 bg-blue-50/60 p-3 text-sm dark:border-blue-900/50 dark:bg-blue-950/20">
      <div className="flex items-center gap-1.5 font-medium text-blue-800 dark:text-blue-300">
        <InfoIcon className="size-4 shrink-0" />
        <span>{title}</span>
      </div>
      <div className="flex items-center gap-2 text-foreground">
        <span className="min-w-0 truncate">{origin || "—"}</span>
        <ArrowRightIcon className="size-3.5 shrink-0 text-muted-foreground" />
        <span className="min-w-0 truncate">{destination || "—"}</span>
      </div>
      {showKm && (
        <div className="text-xs text-muted-foreground">
          Km: <span className="font-medium tabular-nums text-foreground">{km ?? "—"}</span>{code ? ` (${code})` : ""}
        </div>
      )}
    </div>
  )
}
